import { render, staticRenderFns } from "./BaseImg.vue?vue&type=template&id=5e340bdd&scoped=true&"
import script from "./BaseImg.vue?vue&type=script&lang=js&"
export * from "./BaseImg.vue?vue&type=script&lang=js&"
import style0 from "./BaseImg.vue?vue&type=style&index=0&id=5e340bdd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e340bdd",
  null
  
)

export default component.exports